export default __webpack_public_path__ + "static/sample-1-ef3467d526a6df0b407e5b4792c8b5c7.png";